import React from "react";
import { InformatDefaultPage } from "../../../04templates/informat/defaultPage/InformatDefaultPage";
import { GridContainer, GridItem, GridRow } from "pu-crossproduct-components/build/components/Atoms/Grid";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import { Body3 } from "pu-crossproduct-components/build/components/Atoms/Type/"
import { Link, LinkColors } from "pu-crossproduct-components/build/components/Molecules/Navigation/Link";
import { InformatAccountLocked } from "../../../03organisms/informat/informatAccountLockedModal/informatAccountLocked";
import { InformatAccountDisabled } from "../../../03organisms/informat/informatAccountDisabledModal/informatAccountDisabled";
import { InformatCantFindAccount } from "../../../03organisms/informat/informatCantFindAccountModal/informatCantFindAccount";
import {InformatAccountPickerMultipleAccounts} from "./InformatAccountPickerMultipleAccounts";
import {InformatRrnrError} from "../InformatRrnrError/InformatRrnrError";
import {InformatAccountPickerSingeLocked} from "./InformatAccountPickerSingeLocked";
import {InformatAccountPickerSingeDisabled} from "./InformatAccountPickerSingeDisabled";
import {InformatAccountPickerMultipleAccountsOnlyDisabled} from "./InformatAccountPickerMultipleAccountsOnlyDisabled";
import {InformatAccountPickerMultipleAccountsOnlyLocked} from "./InformatAccountPickerMultipleAccountsOnlyLocked";

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-top: 36px;
`

const CantFindAccountHolder = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  max-width: 710px;
  margin-top: 24px;
`

export interface IAccount {
    accountLogin: string
    accountName: string
    isDisabled: boolean
    isLocked: boolean
    accountId: string
}

export interface InformatAccountPickerProps {
    userFirstName: string
    accounts: IAccount[]
    onClick: (account: IAccount) => void
}


const onLockedThenOnName = (a: IAccount, b: IAccount) => {

    const lockedSorter = (a: IAccount, b: IAccount) => (a.isLocked < b.isLocked)
        ? -1
        : (a.isLocked === b.isLocked)
            ? 0
            : 1;

    const nameSorter = (a: IAccount, b: IAccount) => (a.accountName.toUpperCase() < b.accountName.toUpperCase()) ? -1 : 1;
    return lockedSorter(a, b) || nameSorter(a, b);
}


export const InformatAccountPicker: React.FC<InformatAccountPickerProps> = props => {

    const { t } = useTranslation();

    const [openLockedModal, SetOpenLockedModal] = React.useState<boolean>(false);
    const [openDisabledModal, SetOpenDisabledModal] = React.useState<boolean>(false);
    const [openCantFindAccount, SetOpenCantFindAccount] = React.useState<boolean>(false);

    const disabledAccounts = props.accounts.filter(a => a && a.isDisabled).sort(onLockedThenOnName);
    const lockedAccounts = props.accounts.filter(a => a && a.isLocked).sort(onLockedThenOnName);
    const hasOnlyASingleLockedAccount = props.accounts.length === 1 && props.accounts[0].isLocked;
    const hasOnlyDisabledAccounts = props.accounts.length === disabledAccounts.length;
    const hasOnlyLockedAccounts = props.accounts.length === lockedAccounts.length;

    const clickHandle = (account: IAccount) => {
        account.isDisabled
            ? SetOpenDisabledModal(true)
            : account.isLocked
                ? SetOpenLockedModal(true)
                : props.onClick(account)
    }

    if (props.accounts.length > 0) {
        return (
            <InformatDefaultPage>
                <GridContainer>
                    <GridRow>
                        <GridItem col={0} laptop={2} />
                        <GridItem col={12} laptop={8}>
                            <Content>


                            {
                                props.accounts.length > 1
                                    ? hasOnlyDisabledAccounts
                                        ? <InformatAccountPickerMultipleAccountsOnlyDisabled {...{...props, onClick: clickHandle}} />
                                        : hasOnlyLockedAccounts
                                            ? <InformatAccountPickerMultipleAccountsOnlyLocked {...{...props, onClick: clickHandle}} />
                                            : <InformatAccountPickerMultipleAccounts {...{...props, onClick: clickHandle}} />
                                    : hasOnlyASingleLockedAccount
                                        ? <InformatAccountPickerSingeLocked {...{...props, onClick: clickHandle}} />
                                        : <InformatAccountPickerSingeDisabled {...{...props, onClick: clickHandle}} />
                            }



                            <CantFindAccountHolder>
                                <Link onClick={() => SetOpenCantFindAccount(true)} color={LinkColors.type}><Body3><Trans t={t}>twoFactorInformatAccountPickerCannotFindAccount</Trans></Body3></Link>
                            </CantFindAccountHolder>
                            </Content>
                        </GridItem>
                        <GridItem col={0} laptop={2} />
                    </GridRow>
                </GridContainer>
                <InformatAccountLocked open={openLockedModal} onClose={() => SetOpenLockedModal(false)} />
                <InformatAccountDisabled open={openDisabledModal} onClose={() => SetOpenDisabledModal(false)} />
                <InformatCantFindAccount open={openCantFindAccount} onClose={() => SetOpenCantFindAccount(false)} />
            </InformatDefaultPage>)
    }

    return <InformatRrnrError />
}
